var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialYa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1090_12490)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 7.99998C16.5 6.41773 16.0308 4.87101 15.1518 3.55542C14.2727 2.23982 13.0233 1.21446 11.5615 0.608958C10.0997 0.00345721 8.49113 -0.154957 6.93928 0.153725C5.38743 0.462406 3.96197 1.22432 2.84315 2.34314C1.72433 3.46196 0.962402 4.88744 0.65372 6.43928C0.345038 7.99113 0.50347 9.59966 1.10897 11.0615C1.71447 12.5233 2.73984 13.7727 4.05543 14.6517C5.37102 15.5308 6.91774 16 8.49999 16C9.55057 16 10.5909 15.7931 11.5615 15.391C12.5321 14.989 13.414 14.3997 14.1569 13.6569C14.8997 12.914 15.489 12.0321 15.891 11.0615C16.2931 10.0909 16.5 9.05055 16.5 7.99998Z",
    fill: "#FC3F1D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.56658 4.53336H8.83614C7.46802 4.53336 6.76657 5.23481 6.76657 6.23771C6.76657 7.39713 7.26512 7.90149 8.26802 8.60294L9.1028 9.18265L6.70281 12.7826H4.8999L7.06801 9.58265C5.83323 8.6783 5.13178 7.8435 5.13178 6.37683C5.13178 4.54495 6.40136 3.31018 8.83614 3.31018H11.2361V12.8116H9.56658V4.53336Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1090_12490"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialYa);
export default __webpack_public_path__ + "static/media/social_ya.4538fba94c3f9030b3413e2f84ea44f1.svg";
export { ForwardRef as ReactComponent };